<template>
    <div class="field-container" v-bind:class="{'supplementary-field': field.triggeredByAnswerOptionId}">
        <div v-if="field.type === 'checkbox'" class="fields-container">
            <CheckBoxField :preview="preview" :fields="fields" :colors="colors" :field="field"></CheckBoxField>
        </div>
        <div v-else-if="field.type === 'radiobutton'" class="fields-container">
            <RadioField :preview="preview" :fields="fields" :colors="colors" :field="field"></RadioField>
        </div>
        <div v-else-if="field.type === 'range'" class="fields-container">
            <RangeField :outOfFive="outOfFive" :preview="preview" :fields="fields" :colors="colors" :field="field"></RangeField>
        </div>
        <div v-else-if="field.type === 'number'" class="fields-container">
            <NumberField :preview="preview" :fields="fields" :colors="colors" :field="field"></NumberField>
        </div>
        <div v-else-if="field.type === 'string'" class="fields-container">
            <StringField :preview="preview" :fields="fields" :colors="colors" :field="field"></StringField>
        </div>
        <div v-else-if="field.type === 'text'" class="fields-container">
            <TextField :preview="preview" :fields="fields" :colors="colors" :field="field"></TextField>
        </div>
        <div v-else-if="field.type === 'yes_no'" class="fields-container">
            <RadioField :preview="preview" :fields="fields" :colors="colors" :field="field" type="yes_no"></RadioField>
        </div>
        <div v-else-if="field.type === 'explanation'" class="fields-container">
            <ExplanationField :preview="preview" :fields="fields" :colors="colors" :field="field" type="yes_no"></ExplanationField>
        </div>
    </div>
</template>

<script>
    import RadioField from '../Question/Fields/RadioField'
    import RangeField from '../Question/Fields/RangeField'
    import CheckBoxField from '../Question/Fields/CheckBoxField'
    import TextField from '../Question/Fields/TextField'
    import NumberField from '../Question/Fields/NumberField'
    import StringField from '../Question/Fields/StringField'
    import ExplanationField from '../Question/Fields/ExplanationField'

    export default {
        name: 'FieldSelector',
        props: ['fields', 'field', 'colors', 'preview', 'outOfFive'],
        computed: {
            //
        },
        components: {
            ExplanationField,
            RadioField,
            RangeField,
            CheckBoxField,
            TextField,
            NumberField,
            StringField
        }
    }
</script>

<style scoped>
    .field-container,
    .fields-container{
        width: 100%;
    }
  .supplementary-field {
      margin-top: 0;
      padding-left: 15%;
      max-width: 85%;
      margin-bottom: 0;
  }
</style>
